import CreateTag from './CreateTag';

export default CreateTag;
